import { OrderSourceChannel } from '@admin-panel/types';
import { AndroidLogoIcon, AppleLogoIcon, DeviceMobileIcon, GlobeIcon } from '@phosphor-icons/react';
import { Tag } from 'antd';

export const SOURCE_CHANNEL_OPTIONS: Array<{
  value: OrderSourceChannel;
  label: string;
  shortLabel: string;
  icon: React.ReactNode;
  color: string;
}> = [
  {
    value: 'IOS',
    color: 'default',
    label: 'iOS',
    shortLabel: 'iOS',
    icon: <AppleLogoIcon />,
  },
  {
    value: 'ANDROID',
    color: 'green',
    label: 'Android',
    shortLabel: 'Android',
    icon: <AndroidLogoIcon />,
  },
  {
    value: 'WEB',
    color: 'blue',
    label: 'Web',
    shortLabel: 'Web',
    icon: <GlobeIcon />,
  },
  {
    value: 'MWEB',
    color: 'cyan',
    label: 'Mobile Web',
    shortLabel: 'MWeb',
    icon: <DeviceMobileIcon />,
  },
];

const sourceChannelConfig: Record<OrderSourceChannel, (typeof SOURCE_CHANNEL_OPTIONS)[number]> =
  SOURCE_CHANNEL_OPTIONS.reduce(
    (acc, option) => {
      acc[option.value] = option;
      return acc;
    },
    {} as Record<OrderSourceChannel, (typeof SOURCE_CHANNEL_OPTIONS)[number]>,
  );

export const SourceChannelTag = (props: {
  sourceChannel?: OrderSourceChannel | string;
  bordered?: boolean;
  style?: React.CSSProperties;
}) => {
  if (!props.sourceChannel) {
    return null;
  }

  const sourceChannel = sourceChannelConfig[props.sourceChannel as OrderSourceChannel];

  return (
    <Tag
      bordered={props.bordered ?? false}
      color={sourceChannel?.color ?? 'default'}
      icon={sourceChannel?.icon ?? <GlobeIcon />}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4, ...props.style }}
    >
      {sourceChannel?.label ?? props.sourceChannel}
    </Tag>
  );
};
